type Props = {
  label: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  disabled?: boolean;
};

export const Link = (props: Props) => {
  const { label } = props;

  return (
    <a
      {...props}
      data-disabled={props.disabled ? 'true' : 'false'}
      className="text-action-hyperlink
                  hover:text-action-hyperlink-hover
                  hover:cursor-pointer
                  data-[disabled=true]:text-intent-focus-3
                  data-[disabled=true]:pointer-events-none
                  data-[disabled=true]:cursor-default
                  data-[disabled=true]:hover:bg-white/0"
    >
      {label}
    </a>
  );
};
